// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  --background: #e0e0e0;
  --color: #1e1e1e;
  --padding-top: 2px;
  --padding-bottom: 2px;
  --padding-start: 20px;
  --padding-end: 20px;
}

/* Center wrapper for datetime pickers */
.picker-center {
  display: flex;
  justify-content: center;
}

.picker-center ion-datetime {
  max-width: 360px;
  width: 100%;
}

.picker-bg {
  background: #f4f5f8; /* Ionic light background */
}`, "",{"version":3,"sources":["webpack://./src/app/appointments-new/appointments-new.page.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;AAAF;;AAGA,wCAAA;AACA;EACE,aAAA;EACA,uBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;AAAF;;AAGA;EACE,mBAAA,EAAA,2BAAA;AAAF","sourcesContent":["ion-item-divider {\n  --background: #e0e0e0;\n  --color: #1e1e1e;\n\n  --padding-top: 2px;\n  --padding-bottom: 2px;\n  --padding-start: 20px;\n  --padding-end: 20px;\n}\n\n/* Center wrapper for datetime pickers */\n.picker-center {\n  display: flex;\n  justify-content: center;\n}\n\n.picker-center ion-datetime {\n  max-width: 360px;\n  width: 100%;\n}\n\n.picker-bg {\n  background: #f4f5f8; /* Ionic light background */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
